import * as React from "react";
import { MinusCircleOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";

interface CommandTagItemProps {
  index: number;
  name: string;
  value: string;
  onRemove: () => void;
  onChange: (index: number, name: string, value: string) => void;
}
export const CommandTagItem: React.FC<CommandTagItemProps> = ({ index, name, value, onRemove, onChange }) => {
  return (
    <>
      <div className={`relative flex items-center gap-2`}>
        <Input placeholder={"Name"} value={name} onChange={(e) => onChange(index, e.target.value, value)} />
        <Input placeholder={"Value"} value={String(value)} onChange={(e) => onChange(index, name, e.target.value)} />
        <Button onClick={onRemove} type={`text`} danger icon={<MinusCircleOutlined />} />
      </div>
    </>
  );
};
